var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    stroke: "#000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.309 9.86l4.99-5.85c.19-.225.522-.36.855-.36.713 0 1.236.63 1.046 1.26l-2.044 5.94h4.752c1.189 0 2.091.99 1.854 2.115l-1.14 6.3c-.143.855-.951 1.485-1.854 1.485H7.453v-8.64c0-.81.286-1.62.856-2.25zM5.55 11.747h1.902v9H5.55c-1.046 0-1.901-.81-1.901-1.8v-5.4c0-.99.855-1.8 1.9-1.8z",
    strokeWidth: 1.4249999999999998
  }))));
}
export default SvgThumbUp;